import { ICompredScript } from '../../models/ICompredScript';
import * as types from './actionTypes.diffMode';

export const openDiffMode = ({ projectName, scriptName }) => ({
    type: types.OPEN_DIFF_MODE_REQ,
    projectName, scriptName
});

export const fillDiffMode = ({ projectId, environment }) => ({
    type: types.FILL_DIFF_MODE_REQ,
    projectId,
    environment
});

export const compareVersions = ({ projectId, fromTagId, toTagId }) => ({
    type: types.COMPARE_VERSIONS_REQ,
    projectId, fromTagId, toTagId
});

export interface IChangeSelectedScriptParams {
    script: ICompredScript
}
export const changeSelectedScript = ({ script }: IChangeSelectedScriptParams) => ({
    type: types.CHANGE_SELECTED_SCRIPT_REQ,
    script
});